/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import type { HTMLAttributes } from 'react';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';
import { Skeleton } from '../skeleton/skeleton.component';

interface ListLoadingStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'className' | 'style'> {
  style?: stylex.StyleXStyles;
}

const ListLoadingStateContext = createContext<ContextValue<ListLoadingStateProps, HTMLDivElement>>({});

const ListLoadingState = forwardRef((props: ListLoadingStateProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, ListLoadingStateContext);

  const { style, ...coreProps } = props;

  return (
    <div ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      <Skeleton style={styles.item} />
      <Skeleton style={styles.item} />
      <Skeleton style={styles.item} />
      <Skeleton style={styles.item} />
    </div>
  );
});

const styles = stylex.create({
  base: {
    padding: 12,
    gap: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    borderRadius: 2,
    marginBlock: 10,
    paddingInline: 12,
    height: 10,
    width: '100%',
  },
});

export { ListLoadingState, ListLoadingStateContext, type ListLoadingStateProps };
